'use client';

import './index.scss';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import Play from './icons/Play';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { ItfEcoDialogMultiMedia } from 'eco-design/base/eco-dialog-multi-media/type';

const EcoDialogMultiMedia = dynamic(() => import('eco-design/base/eco-dialog-multi-media'), { ssr: false });

export default function IndexClient({ list, prefixCls, id, bgColor: PBg }: { list: any[]; prefixCls: string; id: string; bgColor: string }) {
    const [media, setMedia] = useState<ItfEcoDialogMultiMedia | null>(null);

    const handleOpenDialog = (item: any) => {
        const { mediaType, img, img_h5, video, youtube, name, text, modal_link_text, modal_link_href } = item;
        setMedia({
            mediaType,
            img,
            video,
            youtube,
            name,
            text,
            linkText: modal_link_text,
            linkUrl: modal_link_href,
        });
    };

    const handleGtmBtn = (val: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'banner_switch',
            position: `Homepage_Swiper_4_${val}`,
            button_name: val,

            __btn_id1: `editor-${id} .stxwkpjp-swiper-${val}`,
            __btn_id2: `stxwkpjp-swiper-${val}`,
            __btn_type: 'common',
        });
    };

    return (
        <div className={`${prefixCls}-items`}>
            <Swiper
                className={`${prefixCls}-swiper`}
                modules={[Navigation]}
                navigation={{ prevEl: `#editor-${id} .stxwkpjp-swiper-Left`, nextEl: `#editor-${id} .stxwkpjp-swiper-Right` }}
                spaceBetween={12}
                slidesPerView="auto"
            >
                {list.map((item: any, i: number) => {
                    const { bgColor = 'transparent', title, desc, img, img_h5 } = item;
                    return (
                        <SwiperSlide className={`${prefixCls}-swiper-slide ${prefixCls}-item`} key={i} style={{ backgroundColor: bgColor }}>
                            <div
                                className={`${prefixCls}-item-img ${bgColor === 'transparent' || PBg === bgColor ? 'radius' : ''}`}
                                onClick={() => handleOpenDialog(item)}
                            >
                                <EcoImg pc={img} pad={img_h5} alt={title} />
                                <div className={`${prefixCls}-item-play`}>
                                    <Play />
                                </div>
                            </div>
                            <div className={`${prefixCls}-item-info`}>
                                {title && <h4 className={`${prefixCls}-item-info-title`}>{title}</h4>}
                                {desc && (
                                    <p className={`${prefixCls}-item-info-desc`}>
                                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1777096972016/ef.jpg" alt="EcoFlow" />
                                        <span>{desc}</span>
                                    </p>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
                <div className={`${prefixCls}-control`}>
                    <div
                        className={`swiper-button-prev GtmModuleData-btn-common stxwkpjp-swiper-Left`}
                        data-btn-id="stxwkpjp-swiper-Left"
                        onClick={() => handleGtmBtn('Left')}
                    ></div>
                    <div
                        className={`swiper-button-next GtmModuleData-btn-common stxwkpjp-swiper-Right`}
                        data-btn-id="stxwkpjp-swiper-Right"
                        onClick={() => handleGtmBtn('Right')}
                    ></div>
                </div>
            </Swiper>
            {media && <EcoDialogMultiMedia {...media} callback={() => setMedia(null)} />}
        </div>
    );
}
